import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";

const Start = {
  Type: "start",
  Empty: function () {
    return {
      id: "start", // This must be start!
      type: Start.Type,
      delay: 0,
      showTyping: false,
      name: "",
      onCompleteGoto: null
    };
  },

  PlumbData: function (node: any) {
    return TabNodeLayoutData({
      node: node,
      hideInput: true,
      title: "Start",
      baseWidth: 90,
      tabs: [{ id: "onCompleteGoto", source: "onCompleteGoto", target: node.onCompleteGoto }]
    });
  },

  InspectorPanel: class StartInspectorPanel extends NodePanel {
    // constructor(props) {
    //   super(props);
    //   this.changeQuestName = this.changeQuestName.bind(this)
    // }

    //
    //  changeQuestName(event:any) {
    //    const value = event.target.value;
    //    let node =  JSON.parse(JSON.stringify(this.props.node));
    //    node.name = value;
    //    this.props.updateNode(node, this.props.node)
    //    this.props.changeQuestName(this.props.selectedQuest, value);
    // }

    render() {
      if (!this.props.selectedQuest) {
        return <></>;
      }

      return (
        <div>
          <div className="panel start_panel">
            <InspectorNodeHeader title="Start" />
          </div>
        </div>
      );
    }
  }
};
export default Start;
